import { getScreenshotServerUrl } from '../models/Application';
import { taskErrorUrl } from '../../redesign/javascript/routing/routes';

export const sendScreenshotRequest = async ({
  polyfillData,
  s3Response,
  taskId,
  screenshotServerUrl,
  projectId,
  bugherdUrl,
  userId
}) => {
  const response = await window.fetch(
    screenshotServerUrl || getScreenshotServerUrl(),
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-bugherd-task-id': taskId?.toString() || '',
        'X-bugherd-project-id': projectId?.toString() || ''
      },
      body: JSON.stringify({
        basicAuthPresent: polyfillData.basicAuthPresent || false,
        projectDetailsUrl: polyfillData.projectDetailsUrl,
        s3: s3Response,
        errorUrl: taskErrorUrl({ taskId, bugherdUrl, projectId }),
        projectId,
        organizationId: polyfillData.organizationId,
        userId,
        taskId
      })
    }
  );
  if (response.ok) {
    return;
  } else {
    throw new Error(
      `Screenshot server request failed with status - ${response.status}`
    );
  }
};

type RegenerateScreenshotFromServer = {
  screenshotServerUrl: string;
  s3Response: unknown;
  taskId: number;
  projectId: number;
  userId?: number;
  bugherdUrl: string;
  organizationId: number;
  projectDetailsUrl?: string;
  basicAuthPresent?: boolean;
  screenshotKey: string;
};
export const regnerateScreenshotFromServer = async ({
  screenshotServerUrl,
  s3Response,
  taskId,
  bugherdUrl,
  projectId,
  userId,
  organizationId,
  projectDetailsUrl,
  basicAuthPresent,
  screenshotKey
}: RegenerateScreenshotFromServer): Promise<void> => {
  const regenerateUrl = `${screenshotServerUrl}regenerate`;

  const response = await fetch(regenerateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    body: JSON.stringify({
      s3: s3Response,
      errorUrl: taskErrorUrl({ taskId, bugherdUrl, projectId }),
      projectId,
      organizationId,
      taskId,
      userId,
      projectDetailsUrl,
      basicAuthPresent,
      screenshotKey
    })
  });
  if (response.ok) {
    return;
  } else {
    throw new Error('Unable to regenerate screenshot from server');
  }
};
